module.exports = __webpack_public_path__ + "media/images/new_culture/approach-no-footer-d672b14ced35cd16689e23c63d78ecf5.png";